/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestSubmissionsNotificationActionData } from './ArtistRemixContestSubmissionsNotificationActionData';
import {
    ArtistRemixContestSubmissionsNotificationActionDataFromJSON,
    ArtistRemixContestSubmissionsNotificationActionDataFromJSONTyped,
    ArtistRemixContestSubmissionsNotificationActionDataToJSON,
} from './ArtistRemixContestSubmissionsNotificationActionData';

/**
 * 
 * @export
 * @interface ArtistRemixContestSubmissionsNotificationAction
 */
export interface ArtistRemixContestSubmissionsNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestSubmissionsNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {ArtistRemixContestSubmissionsNotificationActionData}
     * @memberof ArtistRemixContestSubmissionsNotificationAction
     */
    data: ArtistRemixContestSubmissionsNotificationActionData;
}

/**
 * Check if a given object implements the ArtistRemixContestSubmissionsNotificationAction interface.
 */
export function instanceOfArtistRemixContestSubmissionsNotificationAction(value: object): value is ArtistRemixContestSubmissionsNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestSubmissionsNotificationActionFromJSON(json: any): ArtistRemixContestSubmissionsNotificationAction {
    return ArtistRemixContestSubmissionsNotificationActionFromJSONTyped(json, false);
}

export function ArtistRemixContestSubmissionsNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestSubmissionsNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': ArtistRemixContestSubmissionsNotificationActionDataFromJSON(json['data']),
    };
}

export function ArtistRemixContestSubmissionsNotificationActionToJSON(value?: ArtistRemixContestSubmissionsNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': ArtistRemixContestSubmissionsNotificationActionDataToJSON(value.data),
    };
}

